// extracted by mini-css-extract-plugin
module.exports = {"ProductList":"ProductList--PaoP8","header":"header--3yrwx","headerLeft":"headerLeft--74Nkn","headerRight":"headerRight--1m_8A","content":"content--3MUw3"};